import styled from 'styled-components'

import { useAppRoutes } from '@root/features/routing'
import { useTranslation } from '@root/shared/localization'
import { InfoMessage, TransactionsIcon } from '@root/shared/ui-kit'

import type { InfoMessageVariant } from '@root/shared/ui-kit'

export type TransactionHistoryListEmptyProps = {
  infoVariant?: InfoMessageVariant
  withRetry?: boolean
  withBackground?: boolean
  transactionsOwner: 'current' | 'another'
}

export const TransactionHistoryListEmpty = ({
  infoVariant = 'dt',
  withRetry = false,
  withBackground,
  transactionsOwner,
}: TransactionHistoryListEmptyProps) => {
  const { t } = useTranslation()
  const { navigateToRoot } = useAppRoutes()

  const handleExploreTokens = () => {
    navigateToRoot()
  }

  return (
    <Root
      icon={<TransactionsIcon />}
      intent="empty"
      variant={infoVariant}
      title={t('transaction.history.empty-title')}
      description={
        transactionsOwner === 'current'
          ? t('transaction.history.empty-description')
          : t('transaction.history.empty-description.another')
      }
      retryText={t('common.explore-tokens')}
      onRetry={withRetry ? handleExploreTokens : undefined}
      withBackground={withBackground}
    />
  )
}

const Root = styled(InfoMessage)`
  height: 100%;
  /* padding-block-end: 14px; */
`
